<template>
	<div class="landing-award-list">
		<inline-svg :src="appStoreRatingSvg" />

		<inline-svg :src="medtechAwardSvg" />

		<inline-svg :src="amountHappyUsersSvg" />
	</div>
</template>

<script>
import appStoreRatingSvg from '@/assets/social-proof/app-store-rating.svg'
import medtechAwardSvg from '@/assets/social-proof/medtech-award.svg'
import amountHappyUsersSvg from '@/assets/social-proof/amount-happy-users.svg'

export default {
	name: 'LandingAwardList',
	setup() {
		return { appStoreRatingSvg, medtechAwardSvg, amountHappyUsersSvg }
	},
}
</script>

<style lang="scss" scoped>
.landing-award-list {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 8px 0 24px 0;
}
</style>
